export const SNOW_CANVAS_SELECTOR = 'data-snow-canvas';
export const SNOW_CANVAS_ELEMENT_CLASS = 'snow-canvas__element';
export const SNOWFLAKE_DENSITY = 0.00015;
export const WIND_ANGLE = 0.3;
